/**
 * Coup de pouce, Attendu 1221 « factoriser un nombre entier positif :
 * 60 = 2² × 3 × 5 » (3e, Multiples et diviseurs, l. 781). Seconde passe 3e
 * (2026-09-13). UNE page STATIQUE partagée par les trois clés.
 *
 * L'image que l'élève a déjà : l'arbre de décomposition (4e, l. 511, notion
 * de nombre premier et « développements sur ce thème »), tel qu'il est
 * dessiné au tableau : je casse en deux, je continue tant qu'un facteur
 * n'est pas premier. 60 → 6 × 10 → 2 × 3 et 2 × 5 ; les nombres premiers
 * en orange (on ne casse plus) ; la ligne du résultat regroupe les deux 2
 * en 2². Vérification : le produit refait donne 60.
 *
 * SACRIFIÉ : 60, l'exemple du programme, sur tout ce qui s'affiche
 * (gen1221.self.test.js).
 */
import { svg } from './1054';

const ORANGE = '#EA580C';
const BLEU = '#2563EB';
const ENCRE = '#1E293B';
const GRIS = '#64748B';

const ligne = (y, contenu, taille = 12, couleur = ENCRE) => `<text x="200" y="${y}" font-size="${taille}" text-anchor="middle" fill="${couleur}">${contenu}</text>`;
const noeud = (x, y, n, couleur, taille = 18) => `<circle cx="${x}" cy="${y}" r="15" fill="white" stroke="${couleur}" stroke-width="1.6"/>
  <text x="${x}" y="${y + 6}" font-size="${taille}" font-weight="bold" text-anchor="middle" fill="${couleur}">${n}</text>`;
const branche = (x1, y1, x2, y2) => `<line x1="${x1}" y1="${y1 + 15}" x2="${x2}" y2="${y2 - 15}" stroke="${GRIS}" stroke-width="1.4"/>`;

const SVG = svg(
    'Un arbre : 60 se casse en 6 fois 10. 6 se casse en 2 fois 3, 10 se casse en 2 fois 5. Les nombres premiers 2, 3, 2, 5 sont en orange : on ne casse plus. 60 égale 2 fois 2 fois 3 fois 5, soit 2 au carré fois 3 fois 5. Vérification : 4 fois 3 fois 5 égale 60.',
    `<!-- 1. l'arbre -->
  ${noeud(200, 30, 60, BLEU, 16)}
  ${branche(200, 30, 140, 84)}
  ${branche(200, 30, 260, 84)}
  ${noeud(140, 84, 6, BLEU)}
  ${noeud(260, 84, 10, BLEU, 16)}
  ${branche(140, 84, 104, 138)}
  ${branche(140, 84, 176, 138)}
  ${branche(260, 84, 224, 138)}
  ${branche(260, 84, 296, 138)}
  ${noeud(104, 138, 2, ORANGE)}
  ${noeud(176, 138, 3, ORANGE)}
  ${noeud(224, 138, 2, ORANGE)}
  ${noeud(296, 138, 5, ORANGE)}
  <text x="200" y="172" font-size="11" text-anchor="middle" fill="${ORANGE}">en orange, les nombres premiers : on ne casse plus</text>

  <!-- 2. le résultat -->
  ${ligne(204, `60 = <tspan fill="${ORANGE}" font-weight="bold">2 × 2 × 3 × 5</tspan> = <tspan font-weight="bold">2² × 3 × 5</tspan>`, 16)}

  <!-- 3. le geste -->
  ${ligne(232, 'Je casse en deux, je continue jusqu’aux nombres premiers.', 12)}
  ${ligne(254, 'Je vérifie : 4 × 3 × 5 = 60.', 12, GRIS)}`,
    270,
);

const AIDE = { pages: [{ titre: 'Je casse jusqu’aux nombres premiers', svg: SVG }] };

const CP_1221 = {
    flash_texte_trou_saisie: AIDE,
    decomposition_qcm_unique: AIDE,
    sens_tableau_vf: AIDE,
};

export default CP_1221;
